import React from "react";
import { ElementsViewer } from "@wuilt/section-preview";
import { migrateElement } from "./form-migrations";
import useElements from "../hooks/useElements";
import { FormProps, FormSettingsExtended, OldFormValue } from "./form-types";

function Form(props: FormProps) {
  const wuiltContext = useElements();
  const element = migrateElement(
    (props?.value as FormSettingsExtended)?.id ||
      (props?.value as OldFormValue)?.form_data?.id,
    props.value
  );

  return (
    <ElementsViewer.Form
      element={element}
      wuiltContext={wuiltContext}
      text={element.settings.texts}
      sectionId={props?.sectionId}
      sectionValueId={element?.id}
      customClassNames={{
        fieldContainerClass: props?.fieldContainerClass,
        textClass: props?.textClass,
        textareaClass: props?.textareaClass,
        actionContainerClass: props?.actionContainerClass,
        buttonClass: props?.buttonClass,
        fileUploadClass: props?.fileUploadClass,
        timeClass: props?.timeClass,
        selectBoxClass: props?.selectBoxClass,
        radioClass: props?.radioClass,
        dateClass: props?.dateClass,
      }}
    />
  );
}

export default Form;
